import React from "react";
import { Link } from "react-router-dom";

// Image imports (using your provided path)
import heroBg from "../../images/bg/hero_bg.png";
import heroIcon from "../../images/icon/animated-gif02.gif";
import featureIcon1 from "../../images/icon/feature-icon01.svg";
import featureIcon2 from "../../images/icon/feature-icon02.svg";
import featureIcon3 from "../../images/icon/feature-icon03.svg";

const HeroSection: React.FC = () => {
  return (
    <section
      className="hero hero-style pos-rel bg_img"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      <div className="container">
        <div className="row">
          {/* ---------- Left Content ---------- */}
          <div className="col-lg-9 col-md-9">
                        <div className="hero-content">
              {/* Korean Slogan Tag */}
              <div
                className="hero-badge mb-3 scale-animation wow"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "8px 22px",
                  background: "rgba(0, 255, 151, 0.08)",
                  border: "1px solid rgba(0, 255, 151, 0.3)",
                  borderRadius: "30px",
                  color: "#00ff97",
                  fontSize: "14px",
                  fontWeight: 600,
                  letterSpacing: "0.5px",
                  backdropFilter: "blur(10px)",
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: "#00ff97",
                    display: "inline-block",
                    boxShadow: "0 0 10px #00ff97",
                  }}
                ></span>
                인간과 기계, 완벽한 동기화의 시작
              </div>

              {/* English Slogan Headline */}
              <h2 className="title scale-animation wow" style={{ fontSize: "62px", lineHeight: "1.15", fontWeight: 700 }}>
                Syncing Minds,{" "}
                <span
                  style={{
                    background: "linear-gradient(90deg, #00ff97 0%, #38bdf8 50%, #c084fc 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    display: "inline-block",
                  }}
                >
                  Moving Worlds.
                </span>
              </h2>

              {/* Vision Description */}
              <p className="sub-title scale-animation wow" style={{ fontSize: "18px", lineHeight: "1.75", color: "#cbcad3" }}>
                <strong style={{ color: "#ffffff", fontWeight: 600 }}>아틀라스 싱크(Atlas Sync)</strong>는 인간의 생각(Neural)을 연결해 거대 로봇과 세상(Atlas)을 움직입니다.<br />
                모두이룸(MODUIRUM)의 수학적 O(1) Constant Memory 및 Physical AI VLA 아키텍처를 기반으로 단일 NVIDIA RTX 6000 Ada 워크스테이션에서 구동되는 차세대 초격차 소버린 인공지능 플랫폼.
              </p>
              <div className="hero-btn scale-animation wow">
                <Link className="thm-btn agency-btn" to="/about">
                  <span className="text">Explore Atlas Sync</span>
                  <span className="arrow">
                    <span className="arrow-icon">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="5.06592"
                          y="19.9785"
                          width="20.5712"
                          height="2.61221"
                          transform="rotate(-40.2798 5.06592 19.9785)"
                          fill="white"
                        />
                        <rect
                          x="7.97095"
                          y="7.24463"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 7.97095 7.24463)"
                          fill="white"
                        />
                        <rect
                          x="11.6523"
                          y="7.54834"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 11.6523 7.54834)"
                          fill="white"
                        />
                        <rect
                          x="15.334"
                          y="7.85205"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 15.334 7.85205)"
                          fill="white"
                        />
                        <rect
                          x="18.7119"
                          y="11.8374"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.7119 11.8374)"
                          fill="white"
                        />
                        <rect
                          x="18.4084"
                          y="15.52"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.4084 15.52)"
                          fill="white"
                        />
                        <rect
                          x="18.104"
                          y="19.2012"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.104 19.2012)"
                          fill="white"
                        />
                      </svg>
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="5.06592"
                          y="19.9785"
                          width="20.5712"
                          height="2.61221"
                          transform="rotate(-40.2798 5.06592 19.9785)"
                          fill="white"
                        />
                        <rect
                          x="7.97095"
                          y="7.24463"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 7.97095 7.24463)"
                          fill="white"
                        />
                        <rect
                          x="11.6523"
                          y="7.54834"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 11.6523 7.54834)"
                          fill="white"
                        />
                        <rect
                          x="15.334"
                          y="7.85205"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 15.334 7.85205)"
                          fill="white"
                        />
                        <rect
                          x="18.7119"
                          y="11.8374"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.7119 11.8374)"
                          fill="white"
                        />
                        <rect
                          x="18.4084"
                          y="15.52"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.4084 15.52)"
                          fill="white"
                        />
                        <rect
                          x="18.104"
                          y="19.2012"
                          width="2.61221"
                          height="2.61221"
                          transform="rotate(-40.2798 18.104 19.2012)"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </span>
                </Link>
                <a href="/riteflow/" className="thm-btn agency-btn" style={{ marginLeft: "12px", background: "rgba(0, 242, 254, 0.15)", border: "1px solid #00f2fe", color: "#00f2fe" }}>
                  <span className="text">Physical AI Factory</span>
                </a>
                <a href="/binasea/" className="thm-btn agency-btn" style={{ marginLeft: "12px", background: "rgba(0, 255, 151, 0.15)", border: "1px solid #00ff97", color: "#00ff97" }}>
                  <span className="text">Binasea NFT Market</span>
                </a>
              </div>

              {/* 4 Moduirum KPI Telemetry Badges */}
              <div className="scale-animation wow" style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "28px" }}>
                <div style={{ background: "rgba(0, 242, 254, 0.08)", border: "1px solid rgba(0, 242, 254, 0.35)", borderRadius: "8px", padding: "8px 14px", color: "#00f2fe", fontSize: "13px", fontFamily: "monospace", fontWeight: 600 }}>
                  ⚡ O(1) CONSTANT MEMORY: 48GB BOUND
                </div>
                <div style={{ background: "rgba(0, 255, 151, 0.08)", border: "1px solid rgba(0, 255, 151, 0.35)", borderRadius: "8px", padding: "8px 14px", color: "#00ff97", fontSize: "13px", fontFamily: "monospace", fontWeight: 600 }}>
                  🖥️ RTX 6000 Ada: SINGLE NODE SOVEREIGN
                </div>
                <div style={{ background: "rgba(56, 189, 248, 0.08)", border: "1px solid rgba(56, 189, 248, 0.35)", borderRadius: "8px", padding: "8px 14px", color: "#38bdf8", fontSize: "13px", fontFamily: "monospace", fontWeight: 600 }}>
                  🤖 VLA LATENCY &lt; 5.0ms MOTOR LOOP
                </div>
                <div style={{ background: "rgba(168, 85, 247, 0.08)", border: "1px solid rgba(168, 85, 247, 0.35)", borderRadius: "8px", padding: "8px 14px", color: "#c084fc", fontSize: "13px", fontFamily: "monospace", fontWeight: 600 }}>
                  🛡️ MIL-STD-810H &amp; EU AI ACT CONFORM
                </div>
              </div>
            </div>
          </div>

          {/* ---------- Right Icon ---------- */}
          <div className="col-lg-3 col-md-3">
            <div
              className="hero-icon wow zoomIn"
              data-wow-delay="700ms"
              data-wow-duration="800ms"
            >
              <img src={heroIcon} alt="Hero icon" />
            </div>
          </div>
        </div>

        {/* ---------- Features ---------- */}
        <div className="row mt-55">
          <div className="col-lg-4 col-md-6 mt-30">
            <div
              className="xb-feature-item wow fadeInUp"
              data-wow-delay="700ms"
              data-wow-duration="600ms"
            >
              <div className="xb-item--inner xb-border">
                <span className="xb-item--icon">
                  <img src={featureIcon1} alt="icon" />
                </span>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Neural Sync (생각의 연결)</h2>
                  <p className="xb-item--content">
                    인간의 뇌파 및 신경(Neural) 신호를 실시간 정밀 동기화하여 초저지연 뉴럴 인터페이스를 구현합니다.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mt-30">
            <div
              className="xb-feature-item wow fadeInUp"
              data-wow-delay="800ms"
              data-wow-duration="600ms"
            >
              <div className="xb-item--inner xb-border">
                <span className="xb-item--icon">
                  <img src={featureIcon2} alt="icon" />
                </span>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Atlas Robotics (거대 로봇 제어)</h2>
                  <p className="xb-item--content">
                    동기화된 신경망을 통해 산업용 매니퓰레이터, 휴머노이드, 거대 로봇을 직관적으로 제어합니다.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mt-30">
            <div
              className="xb-feature-item wow fadeInUp"
              data-wow-delay="900ms"
              data-wow-duration="600ms"
            >
              <div className="xb-item--inner xb-border">
                <span className="xb-item--icon">
                  <img src={featureIcon3} alt="icon" />
                </span>
                <div className="xb-item--holder">
                  <h2 className="xb-item--title">Moving Worlds (세상의 변혁)</h2>
                  <p className="xb-item--content">
                    인간과 기계의 완전한 융합으로 시공간의 한계를 넘어 산업과 환경, 새로운 세상을 움직입니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
